import ReactQuill from "react-quill";
import constants from "../../../constants";
import { getDataFromStorage } from "../../../util";
import React, { useEffect, useContext } from "react";
import AlertContext from "../../../context/AlertContext";
import Progressbar from "../../CommonComponents/Progressbar";
import fullstack from "../../../assets/images/fullstack.svg";
import useAxiosPrivate from "../../../Hooks/useAxiosPrivate";
import BreadCrumbs from "../../CommonComponents/BreadCrumbs";
import ModuleStatusLabel from "../../CommonComponents/ModuleStatusLabel";
import useCommonFunctionHooks from "../../../Hooks/useCommonFunctionHooks";
import { useParams } from "react-router-dom";

export default function LearningPath() {
  const Alert = useContext(AlertContext);

  const axios = useAxiosPrivate();
  const useCommonFunctionHks = useCommonFunctionHooks();
  const { lpid } = useParams();
  const isPreviewLp = new URLSearchParams(window.location.search).get("mode") === "previewlp";
  const isSelfPacedBatch =
    parseInt(localStorage.getItem("batchType"), 10) ===
    constants.BATCH_TYPE.SELF;


  const formatDuration = (minutes) => {
    const hours = minutes / 60;
    const isWhole = hours % 1 === 0;
    const durationHours = isWhole ? hours.toFixed(0) : hours.toFixed(1);

    return `${durationHours} ${durationHours === "1" ? "hr" : "hrs"}`;
  };

  Alert.courseData?.courses?.[0]?.modules.forEach((module) => {
    const itemCount = [];

    if (module.doccontent > 0) {
      itemCount.push({
        type: "Content",
        count: module.doccontent,
      });
    }

    if (module.videocontent > 0) {
      itemCount.push({
        type: "Videos",
        count: module.videocontent,
      });
    }

    if (module.practicecount > 0) {
      itemCount.push({
        type: "Assignment",
        count: module.practicecount,
      });
    }

    if (module.testcount > 0 || module.assignmentcount > 0) {
      itemCount.push({
        type: "Assessment",
        count: module.testcount + module.assignmentcount,
      });
    }

    module.itemCount = itemCount;
  });

  const handleNavigate = (id) => {
    Alert.setTestData({
      setdd: true,
    });

    Alert.setShowNotify({
      show: true,
      title: "Info",
      primaryButton: "Proceed",
      secondaryButton: "Later",
      msg: " Do you want to enroll into this module now?",
      primaryButtonFunction: () => naviageHomeFunction(id),
    });
  };

  const naviageHomeFunction = (id) => {
    useCommonFunctionHks.handleClose();
    sessionStorage.setItem("modId", id);
    setTimeout(() => {
      Alert.navigate("home");
    }, 100);
  };

  useEffect(() => {
    Alert.setIsLoaded(true);

    axios
      .post(
        "/node/learner/course/summary",
        JSON.stringify({
          lpid: isPreviewLp ? lpid : sessionStorage.getItem("lpId"),
          learnerid: getDataFromStorage("learnerid"),
          isPreviewLp : isPreviewLp,
        }),
        useCommonFunctionHks.getHeaderDetailsForAxios()
      )
      .then((res) => {
        if (res.data.resultCode === constants.RESULT_STATUS.SUCCESS) {
          Alert.setIsLoaded(false);
          Alert.setCourseData(res.data.data);

          const modules = res.data.data?.courses?.[0]?.modules.sort(
            (module1, module2) => module1.moduleorderno - module2.moduleorderno
          );

          if (!modules || (modules.length <= 1 && !isSelfPacedBatch)) {
            if (isPreviewLp) {
              previewHome(res.data.data?.courses?.[0]?.modules?.[0]?.modid, "singlemd")
            } else {
              naviageHomeFunction(
                res.data.data?.courses?.[0]?.modules?.[0]?.modid
              );
            }
          }
        } else {
          Alert.setShowNotify({
            show: true,
            title: "Error",
            msg: "Try again",
          });
        }
      })
      .catch((error) => {
        useCommonFunctionHks.getCatchBlockDetails(error);
        Alert.setIsLoaded(false);
      });
  }, []);

/* for preview */
  const previewHome = (modid, from)=>{
    if(from==="multimd"){
      window.open(`/preview/home/${lpid}/module/${modid}?mode=preview`, "_blank");
    } else {
      window.location.href = `/preview/home/${lpid}/module/${modid}?mode=preview`;
    }
  }

  return (
    Alert.courseData?.courses?.[0]?.modules?.length > 0 &&
    (Alert.courseData?.courses?.[0]?.modules?.length > 1 || isSelfPacedBatch) && (
      <div className="learningPathMainContainer">
        {!isPreviewLp && <BreadCrumbs />}
        <div className="learningPathName">
          <img src={fullstack} alt="Course" />
          {Alert.courseData?.courses[0]?.lpname}
        </div>

        <div className="moduleMainContainer">
          {Alert.courseData.courses[0].modules.map((module, index) => (
            <div
              key={index}
              className="moduleContainer"
              aria-disabled={
                !module.totalItems ||
                ((module.lockedItems === module.totalItems &&
                  !isSelfPacedBatch)&&!isPreviewLp)
              }
              onClick={() => {
                if (
                  module.lockedItems === module.totalItems &&
                  isSelfPacedBatch && !isPreviewLp
                ) {
                  handleNavigate(module.modid);
                } else if (isPreviewLp) {
                  previewHome(module.modid, "multimd")
                } else {
                  naviageHomeFunction(module.modid);
                }
              }}
            >
              <div className="moduleHeader">
                <div className="moduleName">{module.modname}</div>
                {!isPreviewLp && <ModuleStatusLabel module={module} />}
              </div>
              <div className="moduleSubHeader">
                Module {index + 1} · {formatDuration(module.totalhrs)} ·{" "}
                {module.totalItems && !isPreviewLp
                  ? Math.round(
                      (module.completedItems / module.totalItems) * 100
                    )
                  : 0}{" "}
                % complete
                <div className="moduleSubHeaderProgressBar">
                  <Progressbar
                    bgColor="#EAECF0"
                    barColor="#F55533"
                    percentage={
                     !isPreviewLp ?  Math.round(
                        (module.completedItems / module.totalItems) * 100
                      ) || 0 : 0
                    }
                  />
                </div>
              </div>

              <ReactQuill
                readOnly={true}
                value={module.moddesc}
                className="moduleDescription"
              />

              <div className="moduleItemLabelContainer">
                {module?.itemCount.map((item) => (
                  <ModuleStatusLabel item={item} />
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    )
  );
}
